import React, { useEffect, useState } from 'react';
import {Route,Link,Routes,BrowserRouter,Navigate} from "react-router-dom"
import Dashboard from './components/pages/dashboard';
import Books from './components/pages/books';
import ClassNotes from './components/pages/classNotes';
import Discounts from './components/pages/discounts';
import Login from './components/pages/login';
import Register from './components/pages/register';
import UserCard from './components/pages/userCard';
import Info from './components/pages/info';


import "./style/style.scss"
import Footer from './components/containers/footer';


import menuIcon from './media/icons/menu.png'
import menuIconClosed from './media/icons/menuOpen.png'
import logoutIcon from './media/icons/logout.png'
import registerIcon from './media/icons/register.png'
import loginIcon from './media/icons/login.png'

import { findUserData, logout } from './controllers/user.controller';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getBooksList } from './controllers/books.controller';
import { Toaster } from 'react-hot-toast';

//TODO agregar toasts, sustituir consoles, imagen perfil, QR, usar then y catchs, qr fotocopiadora, olvide contraseña
//TODO pulir detalles, agregar todos libros, agregar parte de subir archivos 
//EXAMPLE DATA
  const example =[
    {Nombre:"Libro 1", Autor:"desc", asignatura: "ninguna", Año: 1900, Estado:"Disponible"}]

function App() {

  const [loginState, setloginState] = useState(false)
  const [userData, setUserData] = useState({email:""})

  const [menuState, setMenuState] = useState(true)
  const [menuSelect, setMenuSelect] = useState("dashboard")

  const [books, setBooks] = useState(example)


  //LOGIN STATE
  const auth = getAuth();
  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setloginState(true);
        setUserData({...userData,email:user.email})
        console.log(user)
        getBooksData()

        // ...
      } else {
        setloginState(false);
      }
  })
  }, [])

  function alreadyLogged(){
    return <Navigate to="/credencial" replace/>
  }

  function logOut() {
    logout()
  }

  //MENU STATE
  function menuDisplay() {
    setMenuState(!menuState)
  }

  //GET DATA FROM BOOKS
  function getBooksData() {
    getBooksList().then(
      data => setBooks(data)
    ).catch(
      e => console.log(e)
    )
  }



  return (
    <BrowserRouter>

            
              {
                menuState===true? 
                <aside className="darkBackground p-2 text-end">
                   <img src={menuIcon} className="whiteImage" alt="menuIconOpened" onClick={menuDisplay}/>
                </aside>
                :
                <aside className="p-2 text-end">
                   <img src={menuIconClosed}  alt="menuIconClosed" onClick={menuDisplay}/>
                   {
                      loginState===true?
                      <div className="d-flex flex-column align-items-center justify-content-center py-3 gap-2">
                          <Link className={menuSelect==="dashboard"? "text-decoration-none regularText brown":"text-decoration-none regularText text-dark"} onClick={() => setMenuSelect("dashboard")} to="/">Dashboard</Link>
                          <Link className={menuSelect==="userCard"? "text-decoration-none regularText brown":"text-decoration-none regularText text-dark"} onClick={() => setMenuSelect("userCard")} to="/credencial">Credencial</Link>
                          <Link className={menuSelect==="fotocopy"? "text-decoration-none regularText brown":"text-decoration-none regularText text-dark"} onClick={() => setMenuSelect("fotocopy")} to="/fotocopiadora">Fotocopiadora</Link>
                          <Link className={menuSelect==="books"? "text-decoration-none regularText brown":"text-decoration-none regularText text-dark"} onClick={() => setMenuSelect("books")} to="/biblioteca">Biblioteca</Link>
                          <Link className={menuSelect==="classNotes"? "text-decoration-none regularText brown":"text-decoration-none regularText text-dark"} onClick={() => setMenuSelect("classNotes")} to="/apuntes">Apuntes</Link>
                          <button onClick={logOut} className='brownBtn'> <img src={logoutIcon} className="whiteImage"/>Cerrar Sesión</button>    
                      </div>
                      :
                      <div className="d-flex flex-column align-items-center justify-content-center py-3 gap-2">

                            <Link className={menuSelect==="dashboard"? "text-decoration-none regularText brown":"text-decoration-none regularText text-dark"} onClick={() => setMenuSelect("dashboard")} to="/">App</Link>
                            
                            <div className="d-flex flex-row gap-2 align-items-center" onClick={() => setMenuSelect("login")}> 
                                <img src={loginIcon} path="loginIcon" width="30px"/>                          
                                <Link className={menuSelect==="login"? "text-decoration-none regularText brown":"text-decoration-none regularText text-dark"} to="/login">Iniciar sesión</Link>
                            </div>
                            
                            <div className="d-flex flex-row gap-2 align-items-center" onClick={() => setMenuSelect("register")}>
                                <img src={registerIcon} path="registerIcon" width="30px"/>
                                <Link className={menuSelect==="register"? "text-decoration-none regularText brown":"text-decoration-none regularText text-dark"} to="/registrarme">Registrarme</Link>
                            </div>
                      </div>
                    }
                </aside>
              }

                   

        <main>
        <Toaster/>
            <Routes>
                <Route exact path='/' element={<Dashboard status={loginState}/>}/>
                <Route path='/login' element={loginState? alreadyLogged():<Login/>}/>
                <Route path='/registrarme' element={<Register/>}/>
                <Route path='/biblioteca' element={loginState?<Books data={books}/>:<Navigate to="/login" replace/>}/>
                <Route path='/apuntes' element={loginState? <ClassNotes userData={userData.email}/>:<Navigate to="/login" replace/>}/>
                <Route path='/fotocopiadora' element={loginState? <Discounts/>:<Navigate to="/login" replace/>}/>
                <Route path='/credencial' element={loginState? <UserCard userData={userData.email} />:<Navigate to="/login" replace/>}/>
                <Route path='/informacion' element={<Info/>}/>

            </Routes>
        </main> 
  
        <Footer/>

    </BrowserRouter>

    
  )
}

export default App